<template>
	<div>
		<vs-button
			color="#A8A8A8"
			type="border"
			icon-pack="feather"
			icon="icon-filter"
			:title="$t('Schedule.FilterByAdditionalFields')"
			@click="activePrompt2 = true"
		></vs-button>
		<vs-prompt
			@cancel="clearValMultiple"
			@accept="acceptAlert"
			:cancel-text="$t('Cancel')"
			:accept-text="$t('Accept')"
			@close="close"
			:is-valid="validFilterForm"
			:active.sync="activePrompt2"
			:title="$t('Filters')"
		>
			<div class="mb-4">
				<p style="text-align: justify" class="mb-2">
					{{ $t("Schedule.FilterByAdditionalFieldsText") }}
				</p>
				<small class="date-label">{{ $t("ObjectType") }}</small>
				<v-select
					id="select-category"
					:disabled="categories.length <= 0"
					v-model="selectedCategory"
					:options="categoriesOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>
			</div>

			<div v-if="dynamicFields.length > 0 && selectedCategory !== null" class="dynamic-field-content">
				<dinamic-fields
					ref="DynamicFields"
					:additionalFields="dynamicFields"
					:additionalInfo="additional_info"
					:category="selectedCategory.category"
					vx_col_class="vx-col w-full sm:w-1/1 md:w-1/1 mb-1"
				></dinamic-fields>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
// Store

import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import DinamicFields from "../DinamicFields/DinamicFields.vue";
import vSelect from "vue-select";

export default {
	components: {DinamicFields, vSelect},
	props: {
		handleAction: {
			type: Function,
		},
	},
	data() {
		return {
			activePrompt: false,
			activePrompt2: false,
			selectedCategory: null,
			categories: [],
			dynamicFields: [],
			additional_info: {},
		};
	},
	computed: {
		validFilterForm() {
			return this.selectedCategory !== null;
		},
		categoriesOptions() {
			return this.categories.map((c) => ({
				label: c.typology_name,
				value: c.category_id,
				category: c,
			}));
		},
	},
	methods: {
		acceptAlert() {
			if (this.selectedCategory) {
				if (this.$refs.DynamicFields !== undefined) {
					// Recuperar todas las propiedades adicionales modificadas desde el componente hijo
					const additional_info = this.$refs.DynamicFields.getAddionalInfo();
					// Transforma la data como la requiere el servicio
					const formatFilters = this.separatedObjects(additional_info);
					this.handleAction("APPLY_FILTERS", formatFilters);
				}
			}
		},
		close() {
			this.selectedCategory = null;
		},
		clearValMultiple() {
			this.selectedCategory = null;
		},

		fetchDataCategory(category) {
			const payload = {
				category,
			};
			this.$store
				.dispatch("moduleCommon/fetchDataRoleStatusCategoryTypology", payload)
				.then((res) => {
					this.categories = res.data.category;
				})
				.catch((err) => console.error(err));
		},
		setDataModelDynamicFields(categoryId) {
			const found = this.categories.find((typology) => typology.category_id === categoryId);
			this.dynamicFields = this.dataModelEventDynamicFields(found);
		},
		/**
		 * retorna un array de objetos que contiene informacion de los campos dinamicos que se renderizan
		 * en el formulario de puntos de puntos de visita
		 * @param {*} tipology objeto que copntien la tipologia de donde se obtienen las propiedades adicionales
		 */
		dataModelEventDynamicFields(category) {
			const dataFields = category.json_properties.filter((element) => element.additional);
			return dataFields.map((element) => {
				return {...element, error: false};
			});
		},
		/**
		 * TODO: Recibe un obejeto y crea un arreglo de obejetos con cada una de las propiedades
		 * @param {Object } additionalInfo object like object = { name: "Juan", age: 25, isMarried: true };
		 */
		separatedObjects(additionalInfo) {
			// Obtiene las propiedades del objeto
			const properties = Object.entries(additionalInfo);
			// Crea un arreglo para almacenar los objetos separados
			const separatedObjects = [];
			const separatedArrayObjects = [];
			// Itera sobre las propiedades del objeto
			for (const [property, value] of properties) {
				// Crea un objeto nuevo con la propiedad actual
				const newObject = {[property]: value};
				// Agrega el objeto nuevo al arreglo
				if (Array.isArray(value) && value.length > 0) {
					separatedArrayObjects.push(newObject);
					continue;
				}
				if (typeof value === "string" && value.length > 0) {
					separatedObjects.push(newObject);
				}
			}
			// return los objetos separados en un arreglo
			return {
				additional_info_multiselect: separatedArrayObjects,
				additional_info_filter: separatedObjects,
			};
		},
	},
	watch: {
		selectedCategory(val) {
			// Setear modelo de datos para renderizar campos dinamicos
			this.additional_info = {};
			if (val) this.setDataModelDynamicFields(val.value);
		},
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.fetchDataCategory("SCHEDULE");
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.dynamic-field-content {
	overflow-y: auto;
	min-height: 150px;
	max-height: 300px;
	overflow-x: hidden;
}
</style>
